import { Copy, ExternalLink, Link2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const MenuLinkCard = ({ hasWa, publicUrl }) => {
  const url = `${(publicUrl || window.location.origin).replace(/\/+$/, "")}/menu`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link menu disalin");
    } catch {
      toast.error("Gagal menyalin, salin manual");
    }
  };
  return (
    <div className="space-y-4 rounded-2xl border border-slate-200 bg-white p-6" data-testid="menu-link-card">
      <div className="flex items-center gap-2">
        <Link2 className="h-4 w-4 text-emerald-700" />
        <h3 className="font-display text-lg font-semibold text-slate-800">Link Menu Pelanggan</h3>
      </div>
      <p className="text-sm text-slate-500">Bagikan link ini ke pelanggan. Mereka bisa melihat menu & harga, lalu mengirim pesanan ke WhatsApp toko.</p>
      <div className="flex gap-2">
        <Input readOnly value={url} className="font-mono text-sm" data-testid="menu-link-input" />
        <Button type="button" variant="outline" onClick={copy} data-testid="menu-link-copy-button"><Copy className="h-4 w-4" /></Button>
        <Button type="button" variant="outline" asChild data-testid="menu-link-open-button">
          <a href={url} target="_blank" rel="noopener noreferrer"><ExternalLink className="h-4 w-4" /></a>
        </Button>
      </div>
      {!publicUrl && <p className="rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-500" data-testid="menu-link-no-public-url">Link ini memakai alamat yang sedang Anda buka. Isi "Alamat Aplikasi" di atas dengan alamat yang sudah dipublikasikan agar link selalu benar.</p>}
      {!hasWa && <p className="rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800" data-testid="menu-link-no-wa">Isi Nomor WhatsApp toko di atas agar pelanggan bisa mengirim pesanan.</p>}
    </div>
  );
};
